import { Services } from 'components/services';

export const ServicesPage = () => {
  return <Services />;
};

export default ServicesPage;
